<div style="max-width: 600px; max-height: 500px; width: 100%; height: 250px; position: relative;">
  @if (loading) {
    <ion-progress-bar type="indeterminate"></ion-progress-bar>
  }
  @if (!loading) {
    <canvas baseChart [datasets]="datasets" [labels]="labels" [options]="options" [colors]="colors"
    chartType="bar"></canvas>
  }
</div>
